import { computed } from 'vue'
import { globalUtils } from '@gat-ship/utils'
import type { SearchedVesselRef } from '@gat-ship/types'
import { searchVesselsRequest } from '../model/vessel-api-calls'

/**
 * Debounced, server-side vessel search backing the `VesselSearchPicker`.
 *
 * Unlike the other ref-data datasources (which fetch a full list once and let
 * the combobox filter client-side), vessels live in a large global master, so
 * every keystroke hits `ref-data/vessels/search`. Mirrors the
 * `usePrincipalSearch` pattern: a debounced input with in-flight abort and a
 * race-safe results ref.
 */
export function useVesselSearchDataSource() {
  const { searchInputValue, searchResults, isSearching, clearAll } =
    globalUtils.composables.useDebouncedSearchInput<SearchedVesselRef>({
      apiCall: (inputValue, signal) =>
        searchVesselsRequest(inputValue ?? '', { signal })
    })

  const vessels = computed<SearchedVesselRef[]>(() => searchResults.value)

  return { searchInputValue, vessels, isSearching, clearAll }
}
